
import { Component, Vue, Prop } from "vue-property-decorator";

import moment from "moment";
moment.locale("es");

@Component({
  watch: {
    GraphsData(newVal, oldVal) {
      (this as any).initGraphs(newVal);
    }
  },
  components: {
    DoughnutGraph: () => import("@/components/DoughnutGraph.vue")
  },
  computed: {},
  filters: {}
})
export default class ClaimsGraphs extends Vue {
  @Prop(Object) readonly GraphsData;
  @Prop(Function) readonly seeMoreClaimsOperations;
  iconExpanded: string = require("@/assets/ico-expand.svg");
  iconCollapsed: string = require("@/assets/ico-collapse.svg");
  databoxes: any = {
    claimsState: {
      isExpanded: false,
      svgPath: this.iconExpanded
    }
  };
  data: any = {
    claimsState: {
      labels: [],
      datasets: {
        backgroundColor: ["#32AE80", "#F3C911", "#DC5A57"],
        data: []
      }
    },
    lastOperations: []
  };
  async mounted() {
    await this.initGraphs(this.GraphsData);
  }
  async initGraphs(newVal) {
    if (!newVal) return;
    this.data.claimsState.datasets.data.push(newVal.claimsApproved);
    this.data.claimsState.datasets.data.push(newVal.claimsPending);
    this.data.claimsState.datasets.data.push(newVal.claimsRejected);
    this.data.claimsState.labels.push("Activas");
    this.data.claimsState.labels.push("Pendientes");
    this.data.claimsState.labels.push("Rechazadas");
    this.data.lastOperations = newVal.claimsLastOperations.map(req => ({
      operation: req.content,
      nombre: req.admin.fullname || req.subscriptor.fullname,
      fecha: moment(req.createdAt).format("DD/MM/YYYY")
    }));
  }
  toggleExpand(index) {
    this.databoxes[index].isExpanded = !this.databoxes[index].isExpanded;
    if (this.databoxes[index].isExpanded)
      this.databoxes[index].svgPath = this.iconCollapsed;
    else this.databoxes[index].svgPath = this.iconExpanded;

    this.$forceUpdate();
  }
}
